import React from 'react';
import { motion } from 'framer-motion';
import Constants from '../../../app/utils/constants'

const StatsSection = () => {
  const { portfolioProjectStatsData } = Constants

  return (
    <section className="w-full mt-15 max-w-[90%] mx-auto">
      
      <div className="w-full border border-[#FFFFFF33] bg-[#FFFFFF0A] backdrop-blur-md p-4 md:p-10">
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-10">
          {portfolioProjectStatsData.map((stat, idx) => {

            const isLeft = idx < 2

            return (
              <motion.div
                key={idx}
                className="flex flex-col items-start text-start 2xl:ml-30 xl:ml-15 lg:ml-10 w-full"
                initial={{ x: isLeft ? -80 : 80, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: false }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
              >
                
                {/* Number — mask fades bottom 35% to transparent */}
                <div className="relative mb-4">
                  <motion.span
                    className="block text-6xl md:text-7xl 2xl:text-8xl font-bold 
                    text-transparent bg-clip-text bg-[#8FE64A]/30
                    [-webkit-text-stroke:0.5px_#8FE64A]"
                    style={{
                      WebkitMaskImage: 'linear-gradient(to bottom, black 55%, transparent 90%)',
                      maskImage: 'linear-gradient(to bottom, black 55%, transparent 90%)',
                    }}
                 
                  >
                    {stat.num}
                  </motion.span>
                </div>

                {/* Heading */}
                <h3 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold font-rajdhani text-white md:mb-4">
                  {stat.heading}
                </h3>

                {/* Points */}
                <ul className="space-y-1">
                  {stat.points.map((point, i) => (
                    <li key={i} className="text-gray-200 font-gilroy-medium text-sm md:text-base lg:text-xl max-w-[250px]">
                      • {point}
                    </li>
                  ))}
                </ul>

              </motion.div>  
            )
          })}
        </div>

      </div>
    </section>
  );
};

export default StatsSection;